import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import { applicationSpaRoutes } from "@shared/constants/routes";
import RouteLoadingFallback from "@components/RouteLoadingFallback";

import { preloadRoute } from "@utils";

const routes = applicationSpaRoutes.simpleDocumentCreation.twoFuturePowBundle;

const loadTwoFuturePowBundle = () => import("../TwoFuturePowBundle");
const LazyTwoFuturePowBundle = lazy(loadTwoFuturePowBundle);

const loadGeneralInformation = () => import("./GeneralInformation");
const loadCustomizationSettings = () => import("./CustomizationSettings");
const loadGreaterGifts = () => import("./GreaterGifts");
const loadRemuneration = () => import("./Remuneration");
const loadGrantorInformation = () => import("./GrantorInformation");
const loadAgentsInformation = () => import("./AgentsInformation");
const loadAgentsAgreement = () => import("./AgentsAgreement");
const loadDocumentCreationLoading = () => import("./DocumentCreationLoading");
const loadApproveDocument = () => import("./ApproveDocument");

export const twoFuturePowBundleRoutes = [
  {
    path: routes.generalInformation,
    load: loadGeneralInformation,
    LazyComponent: lazy(loadGeneralInformation),
  },
  {
    path: `${routes.customizationSettings}/:documentNumber`,
    load: loadCustomizationSettings,
    LazyComponent: lazy(loadCustomizationSettings),
  },
  {
    path: `${routes.greaterGifts}/:documentNumber`,
    load: loadGreaterGifts,
    LazyComponent: lazy(loadGreaterGifts),
  },
  {
    path: `${routes.remuneration}/:documentNumber`,
    load: loadRemuneration,
    LazyComponent: lazy(loadRemuneration),
  },
  {
    path: `${routes.grantorInformation}/:documentNumber`,
    load: loadGrantorInformation,
    LazyComponent: lazy(loadGrantorInformation),
  },
  {
    path: `${routes.agentsInformation}/:documentNumber`,
    load: loadAgentsInformation,
    LazyComponent: lazy(loadAgentsInformation),
  },
  {
    path: `${routes.agentsAgreement}/:documentNumber`,
    load: loadAgentsAgreement,
    LazyComponent: lazy(loadAgentsAgreement),
  },
  {
    path: `${routes.documentCreationLoading}/:documentNumber`,
    load: loadDocumentCreationLoading,
    LazyComponent: lazy(loadDocumentCreationLoading),
  },
  {
    path: `${routes.approveDocument}/:documentNumber`,
    load: loadApproveDocument,
    LazyComponent: lazy(loadApproveDocument),
  },
] as const;

export const TwoFuturePowBundleAppRoutes = (
  <Route
    lazy={preloadRoute(loadTwoFuturePowBundle)}
    path={routes.generalInformation}
    element={
      <Suspense fallback={<RouteLoadingFallback />}>
        <LazyTwoFuturePowBundle />
      </Suspense>
    }
  >
    {twoFuturePowBundleRoutes.map(({ path, load, LazyComponent }) => (
      <Route
        key={path}
        lazy={preloadRoute(load)}
        path={path}
        element={
          <Suspense fallback={<RouteLoadingFallback />}>
            <LazyComponent />
          </Suspense>
        }
      />
    ))}
  </Route>
);
